import { render, staticRenderFns } from "./index.vue?vue&type=template&id=cb795e32&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb795e32')) {
      api.createRecord('cb795e32', component.options)
    } else {
      api.reload('cb795e32', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=cb795e32&", function () {
      api.rerender('cb795e32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/campaigns/list/index.vue"
export default component.exports